export default "__VITE_ASSET__be676790__"